<script>
import OrderNotFoundIcon from '@/assets/images/icons/payment-order-not-found.svg?inline'
import OrderPaymentUnavailableIcon from '@/assets/images/icons/payment-order-unavailable.svg?inline'
import {
  formatThousands
} from '@/utils/helpers'
import Bookings from './ui/Bookings.vue'
import PaymentForm from './views/Form.vue'

export default {
  name: 'order-payment',
  components: {
    Bookings,
    PaymentForm,
    OrderNotFoundIcon,
    OrderPaymentUnavailableIcon
  },
  computed: {
    billingData() {
      return this.$store.getters['payment/billingData']
    },
    isPaymentAvailible() {
      return this.$store.getters['payment/isPaymentAvailible']
    },
    sumWithCommission() {
      return this.billingData.details.amount + this.commission
    },
    commission() {
      const {
        amount,
        commission
      } = this.billingData.details

      return Math.round(amount * (commission / 100))
    }
  },
  created() {
    const { paymentHash } = this.$route.params

    this.$store.dispatch('payment/getBillingData', {
      paymentHash
    })
  },
  beforeDestroy() {
    this.$store.commit('payment/setInitialState')
  },
  methods: {
    formatThousands
  }
}
</script>
<template>
  <div class="order-payment">
    <div
      v-if="billingData.hasError"
    >
      <div class="error-card">
        <order-not-found-icon />
        <div>
          <h1>Заказ не найден</h1>
          <p>
            Проверьте правильность ссылки на оплату<br>
            Для создания нового заказа перейдите в
            <router-link :to="{name: 'ToursSearch'}">
              поиск туров
            </router-link>
          </p>
        </div>
      </div>
    </div>
    <div
      v-else-if="isPaymentAvailible"
    >
      <h1 class="order-payment__header">
        Оплата заказа
        <span
          v-if="!billingData.isLoading"
        >
          №{{ billingData.details.orderId }}
        </span>
      </h1>
      <div
        class="order-payment__wrap"
      >
        <div>
          <div class="order-payment__card">
            <h2 class="order-payment__header">
              Детали заказа
            </h2>
            <div class="order-payment__card-content">
              <h3 class="order-payment__subheader">
                Услуги заказа
              </h3>
              <div
                v-if="billingData.isLoading"
                class="order-payment__loading"
              >
                <b-loading
                  :is-full-page="false"
                  :active="billingData.isLoading"
                />
              </div>
              <bookings
                v-else
              />
              <div>
                <h3 class="order-payment__subheader">
                  Туристы
                </h3>
                <div
                  v-if="billingData.isLoading"
                  class="order-payment__loading"
                >
                  <b-loading
                    :is-full-page="false"
                    :active="billingData.isLoading"
                  />
                </div>
                <div
                  v-else
                  class="order-payment__tourists"
                >
                  <p
                    v-for="(tourist, index) in billingData.tourists"
                    :key="`tourist${index}`"
                    class="order-payment__tourists-item"
                  >
                    {{ tourist }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="order-payment__card">
            <h2 class="order-payment__header">
              Оплата
            </h2>
            <div class="order-payment__price">
              <h3 class="order-payment__subheader">
                Остаток по оплате
              </h3>
              <div
                v-if="billingData.isLoading"
                class="order-payment__loading order-payment__loading--text"
              >
                <b-loading
                  :is-full-page="false"
                  :active="billingData.isLoading"
                />
              </div>
              <div
                v-else
              >
                <p class="order-payment__price-value">
                  {{ formatThousands(sumWithCommission) }} ₽
                </p>
                <p class="order-payment__price-value order-payment__price-value--commission">
                  с учетом комиссии {{ formatThousands(commission) }} ₽
                </p>
              </div>
            </div>
            <payment-form
              v-if="!billingData.isLoading"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="error-card"
    >
      <order-payment-unavailable-icon />
      <div>
        <h1>Оплата недоступна</h1>
        <p>
          Заказ полностью оплачен или услуг, доступных для оплаты нет
        </p>
      </div>
    </div>
  </div>
</template>